module.exports = __webpack_public_path__ + "img/photo.5d68e51e.webp";